import { Variant } from '../nav/GlobalNav/hooks/useVariant';

export type SearchSubmitBehavior =
  | { type: 'none' }
  | {
      type: 'advancedSearch';
      /**
       * Landing page for products that do not use the Billing advanced search
       * page. When omitted, the shared results panel builds the Billing URL
       * (including the active object-type tab).
       */
      href?: string;
    };

/**
 * What committing a Global Nav search means per product variant.
 *
 * Billing matches legacy nav: go to the fullscreen global search page. Other
 * variants opt in here once their app section enables search in
 * `AppSectionFactory` (`top.search`), since visibility and submit behavior are
 * separate concerns.
 */
export const SEARCH_SUBMIT_BEHAVIOR_BY_VARIANT: Record<
  Variant,
  SearchSubmitBehavior
> = {
  [Variant.BILLING]: { type: 'advancedSearch' },
  [Variant.OTR]: { type: 'none' },
  [Variant.ONE_ID_REVENUE]: { type: 'none' },
  [Variant.COLLECTIONS]: { type: 'none' },
  [Variant.ONE_ID_COLLECTIONS]: { type: 'none' },
  [Variant.GENERIC]: { type: 'none' },
  [Variant.UNKNOWN]: { type: 'none' },
};

export function getSearchSubmitBehavior(
  variant: Variant,
): SearchSubmitBehavior {
  return SEARCH_SUBMIT_BEHAVIOR_BY_VARIANT[variant] ?? { type: 'none' };
}
